<template>
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '常量'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="110px" :rules="rules">
      <el-form-item label="常量名称" prop="Name">
        <el-input
          v-model.trim="item.Name"
          placeholder="请输入常量名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="常量编码" prop="Type">
        <el-input
          v-model.trim="item.Type"
          placeholder="请输入常量编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="常量值" prop="SpeNb">
        <el-input
          v-model.trim="item.SpeNb"
          placeholder="请输入常量值"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序值" prop="Sort">
        <el-input-number
          v-model="item.Sort"
          :min="0"
          style="width: 100%"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="备注" prop="Remark">
        <el-input
          v-model.trim="item.Remark"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: {},
      rules: {
        Name: [
          { required: true, message: "常量名称不能为空", trigger: "blur" },
        ],
        Type: [
          { required: true, message: "常量编码不能为空", trigger: "blur" },
        ],
        Sort: [{ required: true, message: "排序值不能为空", trigger: "blur" }],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  created() {},
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
      if (this.value.ID) {
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: this.item.ID
              ? `basic/${itemData.ID}`
              : "basic",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
